export default __webpack_public_path__ + "e3550e56bdbf5a1dc84e7b83daaf93a0.gif";